import * as React from 'react';

const PromptSection = ({ promptElement, }) => promptElement

export default PromptSection
